/* istanbul ignore next */
if (typeof rcm != 'undefined') {
    // RCM is undefined in unit tests
    rcm.addAngularModule('app-ui-country-rules');
}
angular.module('app-ui-country-rules', ['pascalprecht.translate', 'pipe-rat-js']);
